import { firebaseAuth } from '../firebase';
import * as authActions from './actions';

export { authActions };
export * from './action-types';
export { authReducer } from './reducer';
export { getAuthenticated, getEmail, isDemo } from './selectors';

export function initAuth(dispatch) {
  return new Promise((resolve, reject) => {
    const unsub = firebaseAuth.onAuthStateChanged(
      user => {
        dispatch(authActions.initAuth(user));
        unsub();
        resolve();
      },
      error => reject(error),
    );
  });
}



// WEBPACK FOOTER //
// ./src/core/auth/index.js